import React from 'react';
import { PackSelector } from './PackSelector';
import { CheckIcon, TruckIcon, LockIcon } from 'lucide-react';
export function Hero({
  id,
  config,
  selectedPack,
  onPackSelect
}) {
  // Function to handle checkout with Shopify
  const handleAddToCart = () => {
    try {
      // Get quantity based on selected pack
      let quantity = 1;
      if (selectedPack === 'twoGetOne') {
        quantity = 3;
      } else if (selectedPack === 'threeGetTwo') {
        quantity = 5;
      }
      // Use the actual Shopify variant ID provided by the user
      const variantId = config.shopify?.variantId || '52168809939271';
      // Create the Shopify cart URL using myoquell.com domain
      // Using the correct format for Shopify cart URLs
      const shopifyCartUrl = `https://myoquell.com/cart/${variantId}:${quantity}`;
      // Open the cart URL in a new tab to avoid navigation issues
      window.open(shopifyCartUrl, '_blank');
    } catch (error) {
      console.error('Error during checkout:', error);
      alert('There was an error adding the product to cart. Please try again.');
    }
  };
  return <section id={id} className="relative bg-[#1A3C2A]" data-id="element-130">
      {/* Mobile-only full-screen hero image with improved quality */}
      <div className="md:hidden w-full h-screen overflow-hidden" data-id="element-131">
        <div className="relative w-full h-full" data-id="element-132">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/f8Ws1BqC8yTg5FiER6s71f/Natural_Care_Where_Most_Neded_%28Your_Story%29_%281%29.png" alt="Natural Care Where Most Needed - MyoQuell Herbal Knee Patches" className="w-full h-full object-cover object-center" loading="eager" style={{
          imageRendering: 'optimizeQuality',
          backfaceVisibility: 'hidden',
          WebkitBackfaceVisibility: 'hidden'
        }} data-id="element-133" />
        </div>
      </div>
      {/* Desktop hero layout with improved quality */}
      <div className="hidden md:block relative" data-id="element-134">
        <div className="relative" data-id="element-135">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/f8Ws1BqC8yTg5FiER6s71f/Natural_Care_Where_Most_Neded_%28Your_Story%29_%281%29.png" alt="Natural Care Where Most Needed - MyoQuell Herbal Knee Patches" className="w-full object-cover" loading="eager" style={{
          imageRendering: 'optimizeQuality',
          backfaceVisibility: 'hidden',
          WebkitBackfaceVisibility: 'hidden'
        }} data-id="element-136" />
        </div>
      </div>
      {/* Product Info - Below the full-screen image on mobile, centered overlay on desktop */}
      <div className="container mx-auto px-4 py-8 flex justify-center" data-id="element-137">
        <div className="w-full md:w-2/3 lg:w-1/2 bg-white p-8 rounded-lg shadow-lg" data-id="element-138">
          <h1 className="text-3xl md:text-4xl font-serif font-bold mb-3 text-[#1A3C2A] text-center" data-id="element-139">
            Natural Herbal Relief That Actually Sticks
          </h1>
          <p className="text-lg mb-6 text-center" data-id="element-140">
            MyoQuell™ herbal knee patches deliver botanical actives directly
            where your knee needs comfort most.
          </p>
          <div className="bg-[#EFF5EA] p-4 mb-6 rounded-lg" data-id="element-141">
            <div className="flex items-center mb-2" data-id="element-142">
              <div className="w-4 h-4 rounded-full bg-[#6B9C37] mr-2" data-id="element-143"></div>
              <span className="font-medium" data-id="element-144">12 patches per box</span>
            </div>
            <div className="flex items-center mb-2" data-id="element-145">
              <div className="w-4 h-4 rounded-full bg-[#6B9C37] mr-2" data-id="element-146"></div>
              <span className="font-medium" data-id="element-147">Premium herbal formula</span>
            </div>
            <div className="flex items-center" data-id="element-148">
              <div className="w-4 h-4 rounded-full bg-[#6B9C37] mr-2" data-id="element-149"></div>
              <span className="font-medium" data-id="element-150">Up to 8 hours of comfort</span>
            </div>
          </div>
          <PackSelector config={config} selectedPack={selectedPack} onPackSelect={onPackSelect} data-id="element-151" />
          <div className="mt-6" data-id="element-152">
            <button id="hero-buy-button" onClick={handleAddToCart} className="w-full py-4 px-6 bg-[#1A3C2A] text-white text-lg font-medium rounded-full hover:bg-[#142E20] focus:outline-none focus:ring-2 focus:ring-[#6B9C37] focus:ring-offset-2 transition-colors" data-id="element-153">
              BUY NOW
            </button>
          </div>
          <div className="flex flex-wrap justify-between mt-4 text-sm" data-id="element-154">
            <div className="flex items-center mr-4 mb-2" data-id="element-155">
              <CheckIcon size={16} className="text-[#6B9C37] mr-1" data-id="element-156" />
              <span data-id="element-157">60-day money-back</span>
            </div>
            <div className="flex items-center mr-4 mb-2" data-id="element-158">
              <TruckIcon size={16} className="text-[#6B9C37] mr-1" data-id="element-159" />
              <span data-id="element-160">Free shipping</span>
            </div>
            <div className="flex items-center mb-2" data-id="element-161">
              <LockIcon size={16} className="text-[#6B9C37] mr-1" data-id="element-162" />
              <span data-id="element-163">Secure checkout</span>
            </div>
          </div>
        </div>
      </div>
    </section>;
}